import React from 'react';
import { MoreHorizontal } from 'lucide-react';
import styles from './CardMenu.module.scss';

export interface CardMenuButtonProps {
  onClick: (e: React.MouseEvent) => void;
  ariaLabel?: string;
  expanded?: boolean;
  haspopup?: 'menu' | 'dialog';
}

export const CardMenuButton: React.FC<CardMenuButtonProps> = ({
  onClick,
  ariaLabel = 'More actions',
  expanded,
  haspopup = 'menu',
}) => (
  <button
    type="button"
    className={styles.trigger}
    aria-label={ariaLabel}
    aria-haspopup={haspopup}
    aria-expanded={expanded}
    onClick={onClick}
  >
    <MoreHorizontal style={{ width: '1em', height: '1em' }} />
  </button>
);

export default CardMenuButton;
